<div class="dialog admin-concept-edit-concept {{'ignoreClicksModal-' + concept.artifact_name}}">
  <div mat-dialog-title class="modal-header">
    @if (ready) {
      <h1 class="modal-title">
        @if (concept.has_authority) {
          <span>
            {{'TRANS__ADMIN_CONCEPT__VIEW' | translate:{conceptType: data.conceptType.concept_name, name: concept.artifact_name} }}
          </span>
        }
        @else if (concept.artifact_id ) {
          <span>
            {{'TRANS__ADMIN_CONCEPT__EDIT' | translate:{conceptType: data.conceptType.concept_name} }}
          </span>
        }
        @else {
          <span>
            {{'TRANS__ADMIN_CONCEPT__CREATE' | translate:{conceptType: data.conceptType.concept_name} }}
          </span>
        }
      </h1>
    }

    <button
      type="button"
      mat-icon-button
      class="close"
      [tabindex]="-1"
      aria-label="close dialog"
      mat-dialog-close="null"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="modal-body modal-body-edit-fields">
    <div class="modal-main-content">
      @if (!ready) {
        <span class="admin-concept-edit-concept__loading">
          {{ 'TRANS__ADMIN_CONCEPT__EDIT__LOADING' | translate }}
        </span>
      }
      @else {
        <div class="admin-concept-edit-concept__edit-fields-content">
          @if (!concept.has_authority || concept.artifact_id.startsWith('ct_')) {
            <app-object-edit
              [sectionsContainer]="sectionsContainer"
            ></app-object-edit>
          }
          @else {
            <app-object-view
              [sectionsContainer]="sectionsContainer"
            ></app-object-view>
          }
          @if (concept.artifact_id) {
            <div>
              <span>
                {{ 'TRANS__CONCEPT__FIELD__UPDATED_AT' | translate }}
              </span>
              <span>
                {{updatedAt}}
              </span>
              <span>
                {{'TRANS__CONCEPT__FIELD__UPDATED_BY' | translate }}
              </span>
              <span>
                {{concept.updated_by_id_value}}
              </span>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div mat-dialog-actions class="modal-footer">
    @if (displayPrevNext) {
      <div class="admin-concept-edit-concept__previous-next-button">
        <button
          mat-stroked-button
          [disabled]="isFirst || !ready"
          color="primary"
          (click)="previous()"
        >
          <span>
            {{ 'TRANS__ADMIN_CONCEPT__PREVIOUS' | translate }}
          </span>
        </button>
        <button
          mat-stroked-button
          [disabled]="isLast || !ready"
          color="primary"
          (click)="next()"
        >
          <span>
            {{ 'TRANS__ADMIN_CONCEPT__NEXT' | translate }}
          </span>
        </button>
      </div>
    }
    @if (errorMessage) {
      <div class="error-warn-color">
        {{errorMessage}}
      </div>
    }
    <div
      [matTooltip]="disabledReason"
      [matTooltipDisabled]="!disabled"
    >
      <button
        mat-flat-button
        [disabled]="disabled"
        color="accent"
        class="admin-concept-edit-concept__register-button"
        (click)="store()"
      >
        <span class="bold">
          {{ 'TRANS__ADMIN_CONCEPT__EDIT__SAVE' | translate }}
        </span>
      </button>
    </div>
    <button
      mat-button
      color="accent"
      class="admin-concept-edit-concept__cancel-button"
      (click)="closeEdit(false)"
    >
      <span class="bold">
        {{ 'TRANS__ADMIN_CONCEPT__EDIT__CANCEL' | translate }}
      </span>
    </button>
  </div>
</div>
